export const ProductFeatureIconList = [
  'account-receivable/customer-management',
  'account-receivable/invoice',
  'account-activity',
  'accounts',
  'auto-withdrawal',
  'add-product',
  'api-hit-report/api-inquiry',
  'api-hit-report/api-transactions-data',
  'bank',
  'bank-account',
  'book',
  'bridging-report',
  'bridging-report/v2',
  'business-banking',
  'business-profile',
  'bulk-receipt',
  'dev-config',
  'disbursement/api-biller',
  'disbursement/api-disburse',
  'disbursement/api-offline/cash-out',
  'disbursement/bulk',
  'disbursement/claim-fund',
  'disbursement/international-remittance',
  'disbursement/offline-cash-withdrawal',
  'developer-option',
  'edc',
  'cashPickup',
  'credit-card',
  'expense-analytic',
  'expense-management/bridging-fund',
  'expense-management/corporate-card',
  'expense-management/reimbursement',
  'help-documentation',
  'home',
  'invoice',
  'integration',
  'language-and-timezone',
  'our-services',
  'more-non-tx',
  'more-service',
  'multi-entity',
  'multi-entity-2',
  'multi-account',
  'notifications',
  'notifications-2',
  'payment-link-2',
  'reimburse',
  'request-money/api-offline/cash-in',
  'request-money/cash-delivery',
  'request-money/cash-deposit-machine',
  'request-money/edc',
  'request-money/e-wallet',
  'request-money/offline-cash-deposit',
  'request-money/payment-checkout',
  'request-money/payment-routing',
  'settings',
  'transaction-report',
  'transaction-category',
  'user-management',
  'vendor',
  'virtual-account',
] as const;

export type ProductFeatureIconName = (typeof ProductFeatureIconList)[number];
